import { createReducer } from '@reduxjs/toolkit';

import {
    addFieldError,
    removeFieldError,
    clearFieldErrors,
    setErrorsVisible,
    setFieldErrors,
    addFormError,
    clearFormError,
} from '../actions/fieldErrors';

const initialState = {
    fieldErrors: {},
    formError: null,
    errorsVisible: false,
};

export default createReducer(initialState, {
    [addFieldError]: handleAddError,
    [addFormError]: handleAddFormError,
    [clearFormError]: handleClearFormError,
    [removeFieldError]: handleRemoveError,
    [clearFieldErrors]: handleClearErrors,
    [setFieldErrors]: handleSetErrors,
    [setErrorsVisible]: handleSetErrorsVisible,
});

function handleAddError(state, action) {
    state.fieldErrors[action.payload.name] = action.payload.value;
}

function handleAddFormError(state, action) {
    state.formError = action.payload;
}

function handleClearFormError(state) {
    state.formError = null;
}

function handleRemoveError(state, action) {
    delete state.fieldErrors[action.payload];
}

function handleSetErrors(state, action) {
    state.errorsVisible = true;
    state.fieldErrors = action.payload;
    state.formError = null;
}

function handleClearErrors(state) {
    state.fieldErrors = {};
    state.formError = null;
}

function handleSetErrorsVisible(state, action) {
    state.errorsVisible = action.payload;
}
